// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"Pages_PageHolder__13z6O"};